import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfigService } from "src/app/shared/providers/config.service";
import { CreateUpdateReasonModel, ReasonModel, SearchReasonInputDto } from "../models/reason-model";
import { Observable } from "rxjs";
import { FranchiseAppGlobal } from "src/app/franchise-app-global";
import { PagedResult } from "../models/common/pagination";

@Injectable()
export class ReasonService {
  private env;
  constructor(public http: HttpClient, private config: AppConfigService) {
    this.env = this.config.getConfig();
  }
  Create(input: CreateUpdateReasonModel): Observable<void> {
    var object = JSON.stringify(input);
    let url = this.env.baseUrl + FranchiseAppGlobal.createReason;
    return this.http.post<void>(url, object);
  }
  Update(input: CreateUpdateReasonModel): Observable<void> {
    var object = JSON.stringify(input);
    let url = this.env.baseUrl + FranchiseAppGlobal.updateReason;
    return this.http.put<void>(url, object);
  }
  Dectivate(id: number): Observable<void> {
    let url = this.env.baseUrl + FranchiseAppGlobal.deActivateReason + id;
    return this.http.get<void>(url);
  }
  GetAll(input: SearchReasonInputDto): Observable<PagedResult<ReasonModel>> {
    var object = JSON.stringify(input);
    let url = this.env.baseUrl + FranchiseAppGlobal.getAllReason;
    return this.http.post<PagedResult<ReasonModel>>(url, object);
  }
  GetById(id: number): Observable<ReasonModel> {
    let url = this.env.baseUrl + FranchiseAppGlobal.getReasonById + id;
    return this.http.get<ReasonModel>(url);
  }
}
